import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { State } from "../state";
import { RootState } from "..";
import { useSelector } from "react-redux";

export type NotificationType = 'info' | 'success' | 'warning' | 'error';

export interface NotificationData {
    title?: string;
    content: string;
    type: NotificationType;
    autoHideDuration?: number; // in milliseconds
}

export interface NotificationEntry extends NotificationData {
    id: string;
}

export const notificationSlice = createSlice({
    name: "notifications",
    initialState: {
        notifications: [] 
    } as State.Notifications,
    reducers: {
        /**
         * Löst eine Notification aus
         */
        triggerNotification: (state, action: PayloadAction<NotificationData>) => {
            const notification: NotificationEntry = {
                id: new Date().getTime().toString(), // use timestamp as unique id
                ...action.payload
            }

            // add notification to state
            state.notifications.push(notification);
            
            // REMOVED the setTimeout code - this is now handled in the NotificationCard component
        },

        closeNotification: (state, action: PayloadAction<string>) => {
            const notification = state.notifications.find(notification => notification.id === action.payload);
            if (notification) {
                // remove notification from state
                state.notifications = state.notifications.filter(notification => notification.id !== action.payload);
            }
        }
    }
})

export const { triggerNotification, closeNotification } = notificationSlice.actions;

export const useNotificationSlice = () => useSelector((state: RootState) => state.notification);

export default notificationSlice.reducer;